import React, { useState } from "react";
import { toast } from "react-toastify";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./choosePayment.css";
import ProcessingAnimation from "../../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import RadioButtonOptions from "../../../../../../../merchant/panel/scripts/shared/RadioButtonOptions/RadioButtonOptions.js";
import RighArrow from "../../../../../icons/RightArrow.js";
import FlowDisplay from "../../../../../../../merchant/panel/scripts/shared/FlowDisplayer/FlowDisplayer.js";
import DataLabel from "../../../../../../../merchant/panel/components/dataLabel/dataLabel.js";
import { resolveShippingOptionPrice, } from "../../../../../../db/schema/shipping.js";
import TextInputV2 from "shared/ui/TextInputV2/TextInputV2.js";
import InpostGeowidget from "./InpostGeowidget.js";
import * as shippingStyles from "./shipping.module.css";
//we do It in order to provide compatibility with merchants panel
const defaultToastOptions = {
    position: "top-left",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    autoClose: 9000,
};
export default function ChoosePayment(props) {
    var _a, _b, _c;
    const { isPreview = false, infoBeforePayment, payment } = props;
    const pOptions = [
        ...(payment.cash ?
            [
                {
                    value: "cash",
                    label: (React.createElement("div", { className: "payment-method-option" },
                        "Przy odbiorze",
                        React.createElement("img", { src: "../../assets/icons/cash-on-delivery.svg", width: "36" }))),
                },
            ]
            : []),
        ...(payment.electronic ?
            [
                {
                    value: "electronic",
                    label: (React.createElement("div", { className: "payment-method-option" },
                        "Elektronicznie",
                        React.createElement("img", { src: "../../assets/icons/online-secure-payment.svg", width: "36" }))),
                },
            ]
            : []),
    ];
    const [loading, setLoading] = useState(false);
    const [method, setMethod] = useState(pOptions.length === 1 ? pOptions[0].value : undefined);
    const [form, setForm, totalPrice] = FlowDisplay.useForm(props.totalPrice - props.formInputsPrice, props.componentsList, props.dbFormResults);
    const enabledShippingOptions = ((_a = props.shipping) === null || _a === void 0 ? void 0 : _a.enabled) === true ?
        props.shipping.options.filter((option) => option.enabled)
        : [];
    const isShippingActive = enabledShippingOptions.length > 0;
    const [shippingOptionId, setShippingOptionId] = useState(enabledShippingOptions.length === 1 ?
        enabledShippingOptions[0].id
        : undefined);
    const [address, setAddress] = useState("");
    const [parcelLocker, setParcelLocker] = useState(undefined);
    const selectedShipping = enabledShippingOptions.find((option) => option.id === shippingOptionId);
    const shippingPrice = selectedShipping ? resolveShippingOptionPrice(selectedShipping.price) : 0;
    const isShippingValid = !isShippingActive ||
        (selectedShipping !== undefined &&
            (selectedShipping.kind === "address" ? address.trim() !== ""
                : selectedShipping.kind === "inpost-paczkomat" ?
                    parcelLocker !== undefined
                    : true));
    async function sendSubmit(method) {
        if (isPreview === true)
            return;
        setLoading(true);
        if (isShippingActive) {
            const shippingResult = await executeRequest("/api/public/users/gallery/orders/shipping", "PATCH", {
                optionId: shippingOptionId,
                address: (selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.kind) === "address" ? address : undefined,
                parcelLocker: (selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.kind) === "inpost-paczkomat" ?
                    parcelLocker
                    : undefined,
            });
            if (shippingResult.status !== 200) {
                setLoading(false);
                toast.error("Nie udało się zapisać sposobu dostawy");
                return;
            }
        }
        if ((props === null || props === void 0 ? void 0 : props.flow) !== "inherit" &&
            props.flow !== undefined &&
            props.flow.length > 0) {
            const formResult = await executeRequest("/api/public/users/gallery/flowForm", "PATCH", {
                form,
            });
            if (formResult.status !== 200) {
                setLoading(false);
                if (formResult.status === 400) {
                    return void toast.error("Nieprawidłowo wypełniono pola formularza!");
                }
                toast.error("Nie udało się przesłać formularza");
                return;
            }
        }
        const result = await executeRequest(`/api/public/users/gallery/orders/submitOrder?paymentMethod=${method}`, "GET", {});
        if (result.status == 200) {
            window.open(result.url, "_self");
            return;
        }
        setLoading(false);
        if (result.status == 400) {
            if (result.invalidEmail === true)
                return void toast.error("Podano nieprawidłowy adres email", defaultToastOptions);
            toast.error("Płatność już została zrealizowana lub jest jeszcze w jej trakcie", defaultToastOptions);
            return;
        }
        toast.error("Nie udało się przekierować do serwisu obsługującego płatności", defaultToastOptions);
    }
    return (React.createElement("section", { className: "choosing-payment-container" },
        loading && React.createElement(ProcessingAnimation, { extraMessage: "Poczekaj chwilk\u0119..." }),
        React.createElement("div", { className: "text-before-payment-container" },
            React.createElement(PlainEditor, { label: "", example: infoBeforePayment, onChange: function () { }, editable: false, fullWidth: true })),
        props.flow !== "inherit" && props.flow !== undefined && (React.createElement(FlowDisplay, { components: (_b = props === null || props === void 0 ? void 0 : props.flow) === null || _b === void 0 ? void 0 : _b.map((uuid) => props.componentsList[uuid]), inputState: form, onChange: setForm, outlinedComponent: props.outlinedComponent, componentsList: (_c = props.componentsList) !== null && _c !== void 0 ? _c : {} })),
        isShippingActive && (React.createElement("div", { className: shippingStyles.container },
            React.createElement(RadioButtonOptions, { label: "Spos\u00F3b dostawy:", options: enabledShippingOptions.map((option) => ({
                    value: option.id,
                    label: (React.createElement("div", { className: shippingStyles.option },
                        React.createElement("span", null, option.label),
                        React.createElement("span", { className: shippingStyles.price }, resolveShippingOptionPrice(option.price) === 0 ?
                            "Bezpłatnie"
                            : `${resolveShippingOptionPrice(option.price)} zł`))),
                })), state: shippingOptionId, alignment: "vertical", style: "high-pr", onChange: (id) => setShippingOptionId(id) }),
            (selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.description) && (React.createElement("p", { className: shippingStyles.description }, selectedShipping.description)),
            (selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.kind) === "address" && (React.createElement(TextInputV2, { elementId: "shipping-address", label: "Adres dostawy", value: address, onChange: setAddress })),
            (selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.kind) === "inpost-paczkomat" && (React.createElement(React.Fragment, null,
                React.createElement(InpostGeowidget, { token: props.inpostGeowidgetToken, onSelect: setParcelLocker }),
                parcelLocker && (React.createElement("p", { className: shippingStyles.description },
                    "Wybrany paczkomat: ",
                    React.createElement("b", null, parcelLocker.name),
                    " \u2014",
                    " ",
                    parcelLocker.address)))))),
        React.createElement("div", { className: "order-data-summary-container" },
            React.createElement("h3", null, "Dane zam\u00F3wienia:"),
            isShippingActive && selectedShipping && (React.createElement(DataLabel, { label: "Koszt dostawy", responsive: true, type: "horizontal-no-line" },
                shippingPrice,
                " z\u0142")),
            React.createElement(DataLabel, { importantData: true, label: "Ca\u0142kowita kwota do zap\u0142aty", responsive: true, type: "horizontal-no-line" },
                React.createElement("b", null,
                    totalPrice + shippingPrice,
                    " z\u0142"))),
        React.createElement("div", { className: "payment-method-container" },
            React.createElement(RadioButtonOptions, { options: pOptions, state: method, alignment: "vertical", style: "high-pr", label: pOptions.length > 1 ?
                    "Prosimy wybrać metodę płatności:"
                    : "Metoda płatności:", onChange: (value) => setMethod(value) })),
        React.createElement("div", { className: "menu-buttons-in-payment-chooser" },
            React.createElement(Button, { value: "go_back", text: "Wr\u00F3\u0107 do koszyka", version: "alternative", isActive: true, classNames: "go-back-button", onClick: props.goBack }),
            method && isShippingValid && (React.createElement(Button, { version: "classic", onClick: () => sendSubmit(method) },
                React.createElement("div", { className: "process-payment-button-content" },
                    method === "cash" ? "Złóż zamówienie" : "Przejdź do płatności",
                    React.createElement(RighArrow, { color: "secondary-background" })))))));
}
